import { Crown, UserCog, User as UserIcon } from 'lucide-react';

export const ROLE_COLORS = {
  super_admin: { bg: 'bg-purple-100', text: 'text-purple-700', icon: Crown },
  org_admin: { bg: 'bg-blue-100', text: 'text-blue-700', icon: UserCog },
  user: { bg: 'bg-gray-100', text: 'text-gray-700', icon: UserIcon },
};

export const ROLE_NAMES = {
  super_admin: 'Super Admin',
  org_admin: 'Org Admin',
  user: 'User',
};
